import { InjectionToken } from '@angular/core';
import { MpSnackbarRef } from './mp-snackbar-ref.model';

export const MP_SNACKBAR_DATA = new InjectionToken('MP_SNACKBAR_DATA');
export const MP_SNACKBAR_REF = new InjectionToken<MpSnackbarRef>('MP_SNACKBAR_REF');
